import { stringify } from 'query-string';

import { MAX_LIMIT } from 'config';

interface IOptions {
  limit?: number;
  offset?: number;
  platformFilter?: string[];
  sortBy?: string;
  sortOrder: 'asc' | 'desc';
}

const getArtistOnSocial = (options: IOptions): string => {
  const {
    limit = MAX_LIMIT,
    offset,
    platformFilter,
    sortBy,
    sortOrder,
  } = options;

  const params = stringify({
    limit,
    offset,
    platformFilter,
    sortBy,
    sortOrder,
  });

  return `api/social/top/platforms/artists?${params}`;
};

export default getArtistOnSocial;
